var _excluded = ["as", "variant", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import PropTypes from "prop-types";
import forwardRef from "../../private/forwardRef";
var textProperties = function textProperties(_ref) {
  var theme = _ref.theme,
    variant = _ref.variant;
  var _theme$typography$var = theme.typography[variant],
    fontSize = _theme$typography$var.fontSize,
    fontFamily = _theme$typography$var.fontFamily,
    lineHeight = _theme$typography$var.lineHeight,
    fontWeight = _theme$typography$var.fontWeight,
    textTransform = _theme$typography$var.textTransform,
    letterSpacing = _theme$typography$var.letterSpacing,
    fontVariationSettings = _theme$typography$var.fontVariationSettings;
  return {
    fontSize: fontSize,
    fontFamily: fontFamily,
    lineHeight: lineHeight,
    fontWeight: fontWeight,
    textTransform: textTransform,
    letterSpacing: letterSpacing,
    fontVariationSettings: fontVariationSettings,
    margin: 0
  };
};
var Typography = styled.p.withConfig({
  displayName: "Text__Typography",
  componentId: "sc-vzn7fr-0"
})(textProperties);

/**
 * The Text component which allows you to easily implement the typography scale. By default this element is a `p`.
 *
 * @see [Text documentation](https://construct-kit.reainternal.net/web/text)
 * */
var Text = forwardRef(function (_ref2, ref) {
  var as = _ref2.as,
    variant = _ref2.variant,
    children = _ref2.children,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var _useContext = useContext(ThemeContext),
    legacy = _useContext.legacy;
  var defaultStylesForElement = {
    h1: legacy ? "title01" : "largeTitle",
    h2: legacy ? "title02" : "title01",
    h3: legacy ? "title03" : "title02",
    h4: "title03",
    h5: "overline",
    h6: "overline",
    p: "body01",
    small: legacy ? "caption" : "body02",
    figcaption: legacy ? "body02" : "caption",
    label: "body01",
    strong: "strong"
  };
  var defaultStyleIfAs = typeof as === "string" && defaultStylesForElement[as];
  return /*#__PURE__*/React.createElement(Typography, _extends({
    ref: ref,
    as: as,
    variant: variant || defaultStyleIfAs || "body01"
  }, props), children);
});
Text.displayName = "Text";
Text.propTypes = {
  /** The visual style of the element. If you don't provide a `variant` or an
   * `as` prop, the default is typography style is `body01`.<br />
   * You can provide an `as` prop for a semantic HTML text element which will
   * set an appropriate `variant` for you (e.g.  `as="h1"` implies
   * `variant="title1"`). */
  variant: PropTypes.oneOf(["display", "largeTitle", "title01", "title02", "title03", "subtitle01", "subtitle02", "overline", "body01", "body02", "caption"]),
  /** The contents to be contained within the Text tag. */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
export default Text;
export { H1, H2, H3, H4, H5, H6, P, Small, FigCaption, Strong } from "./ShorthandText";